const coreConfig = {
    HTTP_STATUS_CODES: {
        OK: 200,
        UNAUTHORIZED: 401,
        FORBIDDEN: 403,
        NOT_FOUND: 404,
        INTERNAL_SERVER_ERROR: 500,
        INVALID_CONFIGURATION: 422
    },
    DOCUMENT_GROUP_ID_MAP: {
        equipments: 68,
        masterScope: 69
    },
    apiConfig: {
        reqMethod: {
            GET: 'get',
            POST: 'post',
            PUT: 'put',
            DELETE: 'delete'
        },
        endpoints: {
            login: "login",
            logout: "logout",
            menuList: "/api/menu/list",
            dashboard: "/api/equipment/list",
            history: "/api/securityModLogRecordDetails/list",
            documentGroupLookup: `/api/menu/0?lookups=DocumentGroup`,
            revision: "/api/revision",
            equipment: "/api/equipment",
            equipmentScope: "/api/equipmentScope",
            clientError: "/clientErrorHandler",
            user: "/api/users"
        }
    },
    RegEx: {
        email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    },
    COLUMN_NAMES: {
        MODIFIED_ON: "ModifiedOn",
        MODIFIED_BY_USER: "ModifiedBy",
        CREATED_ON: "CreatedOn",
        ACTION_TYPE: "Action",
        IS_DELETED: "IsDeleted"
    },
    DATE_FORMAT: "MM/DD/YYYY hh:mm:ss A",
    backendUrl: '/backend',
    apiEndpoints: {
        default: '/backend/api/',
        GridPreferenceManager: '/backend/preferences',
        history: '/historyScreen'
    },
    isBasicAuth: import.meta.env.IS_BASIC_AUTH_ENABLED === "true",
    defaultErrorMessage: 'Something Went Wrong',
    headerName: 'Scope Compatibility Matrix',
    draft: 'Draft',
    production: "Production",
    authMethods: {
        basicAuth: 'basicAuth',
        entraIdAuth: 'entraIdAuth'
    },
    colorMapper: {
        Draft: "#efc630",
        "Locked for Approval": "#efc630",
        Production: "#81eb81",
        Archived: "#b5b5b5"
    },
    // scopeApi specifies the validated scopes table api for the equipment
    // parameterSetApi specifies the parameter table api for the equipment
    eqiupmentConfigMap: {
        1: {
            scopeApi: "EquipmentHookupValuesADV",
            columns: [
                { field: 'HookupName', label: 'HOOKUP' },
                { field: 'HookupRev', label: 'REV' }
            ]
        },
        2: {
            scopeApi: "EquipmentHookupValuesADV",
            columns: [
                { field: 'HookupName', label: 'HOOKUP' },
                { field: 'HookupRev', label: 'REV' }
            ]
        },
        3: {
            scopeApi: "EquipmentHookupValuesRAER",
            columns: [
                { field: 'HookupName', label: 'HOOKUP' },
                { field: 'HookupRev', label: 'REV' },
                { field: 'PSRevision', label: 'PSREVISION'},
                { field: 'BleedValve', label: 'BLEEDVALVE'},
                { field: 'En1', label: 'EN1'},
                { field: 'En2', label: 'EN2'},
                { field: 'En3', label: 'EN3'},
                { field: 'En4', label: 'EN4'},
                { field: 'En5', label: 'EN5'}
            ]
        },
        4: {
            scopeApi: "EquipmentHookupValuesISA",
            columns: [
                { field: 'HookupName', label: 'HOOKUP' },
                { field: 'HookupRev', label: 'REV' }
            ]

        },
        6: {
            scopeApi: "EquipmentHookupValuesE3K",
            columns: [
                { field: 'Wallchart', label: 'WALLCHART' },
                { field: 'LeakTest', label: 'LEAKTEST' },
                { field: 'BalloonChannel', label: 'BALLOONCHANNEL' },
                { field: 'Irrigation', label: 'IRRIGATION' },
                { field: 'AuxElevator', label: 'AUXELEVATOR' },
                { field: 'AirChannel', label: 'AIRCHANNEL' },
                { field: 'AwValve', label: 'AWVALVE' },
                { field: 'ValvePorts', label: 'VALVEPORTS' },
                { field: 'BiopsyChannel', label: 'BIOPSYCHANNEL' },
                { field: 'Biopsy2', label: 'BIOPSY2' },
                { field: 'SuctionValve', label: 'SUCTIONVALVE' },
                { field: 'SuctionChannel', label: 'SUCTIONCHANNEL' },
                { field: 'ChannelSelector', label: 'CHANNELSELECTOR' },
                { field: 'US', label: 'US', type: 'boolean' },
                { field: 'OUS', label: 'OUS', type: 'boolean' },
                { field: 'HuluScopeFamily', label: 'Scope Family', hide: true },
                { header: 'Use Alcohol', field: 'Alcohol', label: 'Use Alcohol', width: 150, type: 'boolean', hide: true }
            ]
        },
        8: {
            scopeApi: "EquipmentHookupValuesEPS",
            columns: [
                { field: 'FlowUnit', label: 'FLOWUNIT' },
                { field: 'FlowUnitCatNumber', label: 'FLOWUNITCATNUMBER' },
                { field: 'AccessoryPlacement', label: 'ACCESSORYPLACEMENT' },
                { field: 'SpecialPlacement', label: 'SPECIALPLACEMENT' }
            ]
        },
        9: {
            scopeApi: "EquipmentHookupValuesPROD",
            columns: [
                { field: 'ItemId', label: 'ITEMID' },
                { field: 'SectionId', label: 'SECTIONID' },
                { field: 'UOM', label: 'UOM' }
            ]
        },
        10: {
            scopeApi: "EquipmentHookupValuesRES",
            columns: [
                { field: 'TestResults', label: 'TESTRESULTS' },
                { field: 'QuickConnect', label: 'QUICKCONNECT' }
            ]
        },
        11: {
            scopeApi: "EquipmentHookupValuesSYS1",
            columns: [
                { field: 'Tray', label: 'TRAY' },
                { field: 'QuickConnect', label: 'QUICKCONNECT' },
                { field: 'Endo', label: 'ENDO' }
            ]
        },
        12: {
            scopeApi: "EquipmentHookupValuesE300",
            columns: [
                { field: 'WallchartPTX', label: 'WALLCHARTPTX' },
                { field: 'WallchartAER', label: 'WALLCHARTAER' },
                { field: 'LeakTest', label: 'LEAKTEST' },
                { field: 'Balloon', label: 'BALLOON' },
                { field: 'Aux2', label: 'AUX2' },
                { field: 'AuxElevator', label: 'AUXELEVATOR' },
                { field: 'AirChannel', label: 'AIRCHANNEL' },
                { field: 'ChannelSepawvalve', label: 'CHANNELSEPAWVALVE' },
                { field: 'Biopsy2', label: 'BIOPSY2' },
                { field: 'BiopsyChannel', label: 'BIOPSYCHANNEL' },
                { field: 'SuctionValve', label: 'SUCTIONVALVE' },
                { field: 'SuctionChannel', label: 'SUCTIONCHANNEL' },
                { field: 'Itmm', label: 'ITMM' },
                { field: 'BcidMin', label: 'BCIDMIN' },
                { field: 'BcidMax', label: 'BCIDMAX' }
            ]
        },
        13: {
            scopeApi: "EquipmentHookupValuesINN",
            columns: [
                { field: 'HookupName', label: 'HOOKUP' },
                { field: 'HookupRev', label: 'REV' }
            ]
        },
        14: {
            scopeApi: "EquipmentHookupValuesSYS1",
            columns: [
                { field: 'Tray', label: 'TRAY' },
                { field: 'QuickConnect', label: 'QUICKCONNECT' },
                { field: 'Endo', label: 'ENDO' }
            ]
        },
        15: {
            scopeApi: "EquipmentHookupValuesSYS1",
            columns: [
                { field: 'Tray', label: 'TRAY' },
                { field: 'QuickConnect', label: 'QUICKCONNECT' },
                { field: 'Endo', label: 'ENDO' }
            ]
        },
        16: {
            scopeApi: "EquipmentHookupValuesVPRO",
            columns: [
                { field: 'Flexible', label: 'FLEXIBLE' },
                { field: 'NonLumen', label: 'NONLUMEN' },
                { field: 'Lumen', label: 'LUMEN' }
            ]
        },
        17: {
            scopeApi: "EquipmentHookupValuesVPRO",
            columns: [
                { field: 'Flexible', label: 'FLEXIBLE' },
                { field: 'NonLumen', label: 'NONLUMEN' },
                { field: 'Lumen', label: 'LUMEN' }
            ]
        },
        18: {
            scopeApi: "EquipmentHookupValuesVPRO",
            columns: [
                { field: 'Flexible', label: 'FLEXIBLE' },
                { field: 'NonLumen', label: 'NONLUMEN' },
                { field: 'Lumen', label: 'LUMEN' }
            ]
        },
        19: {
            scopeApi: "EquipmentHookupValuesADV",
            columns: [
                { field: 'HookupName', label: 'HOOKUP' },
                { field: 'HookupRev', label: 'REV' }
            ]
        }
    },
    hookupConfig: 'Hookup',
    equipmentIdMapper: {
        Enspire3000: 6
    }
};
export default coreConfig;